// extracted by mini-css-extract-plugin
module.exports = {"logo-image-absolute":"Logo_logo-image-absolute__3mayS","logo-image":"Logo_logo-image__1NVQO"};